import React from 'react'
import '../../../css/roomPreviewloading.css'
const RoomPreviewLoader=()=>{
    return(<div className="roomPreviewLoader"></div>
    )
}

//Export hoterListLoader
export default RoomPreviewLoader